/* apps/IDSImpactApp/src/app/shared/action-dialog/action-dialog.component.scss */
.action-btn {
  float: right;
}
/*# sourceMappingURL=action-dialog.component.css.map */
